import * as Services from "../services/Services"
import * as Url from "../services/Url"


export const getAllContacts = async() => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_ALL_CONTACT, token)
  return res;
};

export const addContact = async(payload) => {
  let token = localStorage.getItem("token") || null;
  let res = await Services.POST(Url.ADD_CONTACT, payload, token)
  return res;
};

export const updateContact = async(id, payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.PUT(`${Url.UPDATE_CONTACT}/${id}`, payload, token)
  return res;
};

